import i18next from "i18next";
import {useEffect, useRef} from "react";
import {Button, Col, Input} from "antd";
import {getCaptcha} from "../backend/UserBackend";
import {ReloadOutlined, SafetyOutlined} from "@ant-design/icons";

export const RsoCaptchaSmartLogin = (props) => {
  const {
    shouldReloadCaptcha,
    isCaptchaFalse,
    owner,
    name,
    setCaptchaToken,
    setCaptchaImg,
    setClientSecret,
    captchaImg,
    captchaToken,
    isCurrentProvider,
  } = props;

  const defaultInputRef = useRef(null);
  const fetch = () => {
    getCaptcha(owner, name, isCurrentProvider).then((res) => {
      if (res?.type === "Default") {
        setClientSecret(res.captchaId);
        setCaptchaImg(res.captchaImage);
      }
    });
  };
  useEffect(() => {
    fetch();
  }, []);
  const prevReloadCount = useRef(shouldReloadCaptcha);
  const prevCount = useRef(isCaptchaFalse);
  useEffect(() => {
    const shouldReload =
          isCaptchaFalse !== prevCount.current ||
          shouldReloadCaptcha !== prevReloadCount.current;
    if (shouldReload) {
      prevCount.current = isCaptchaFalse;
      setCaptchaToken("");
      setCaptchaImg("");
      setClientSecret("");
      prevReloadCount.current = shouldReloadCaptcha;
      fetch();
    }
  }, [shouldReloadCaptcha, isCaptchaFalse]);

  return (

    <div style={{marginTop: "20px"}}>
      <Col style={{textAlign: "center"}}>
        <div style={{display: "flex", justifyContent: "space-between", width: "100%", gap: "8px"}}>
          <div style={{height: "40px", width: "50%"}}>
            <Input
              className="with-addon-en-input"
              ref={defaultInputRef}
              style={{height: "40px", width: "100%"}}
              value={captchaToken}
              prefix={<SafetyOutlined />}
              placeholder={i18next.t("general:Captcha")}
              onChange={(e) => setCaptchaToken(e.target.value)}
            />
          </div>
          <div className="rso-captcha-reload"
            style={{width: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <Button
              onClick={fetch}
              type="primary"
              style={{
                height: "40px",
                width: "20%",
                borderRadius: "0 5px 5px 0",
                border: "1px solid #ccc",
                marginBottom: "20px",
                cursor: "pointer",
                borderLeft: "0",
              }}>
              <ReloadOutlined />
            </Button>
            <div
              style={{
                borderRadius: "5px 0 0 5px",
                backgroundImage: `url('data:image/png;base64,${captchaImg}')`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "40px",
                width: "80%",
                border: "1px solid #ccc",
                borderRight: "0",
                marginBottom: "20px",
                cursor: "pointer",
              }}
            />
          </div>
        </div>
      </Col>
    </div>
  );
};
